import { Link } from '@remix-run/react'
import { type HTMLMotionProps, motion } from 'framer-motion'
import { type ComponentProps } from 'react'

type MotionLinkSpecificProps = HTMLMotionProps<'a'>

type MergedLinkMotionProps = ComponentProps<typeof Link> &
	MotionLinkSpecificProps

const MotionLink = motion(Link)

export default function AnimatedLink({
	children,
	...props
}: MergedLinkMotionProps) {
	return (
		<MotionLink
			whileHover={{ scale: 1.05 }}
			transition={{ duration: 0.2 }}
			{...props}
		>
			{children}
		</MotionLink>
	)
}
